module.exports = __webpack_public_path__ + "static/img/9673a8e1ea0d054ad1b604d3dd4bba34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/workflow_active_05.png
// module id = xdkf
// module chunks = 1